import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHubspotComponent } from './simple-icons-hubspot.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHubspotComponent ],
    exports:      [ SimpleIconsHubspotComponent ],
    bootstrap:    []
})
export class SimpleIconsHubspotModule {}
